import type { CredentialProgress } from '@dosfilos/application';
import { callable } from '../callable';

export type {
  CredentialProgress,
  CredentialProgressRow,
  CredentialProgressInProgressRow,
  RecordedGraduation,
} from '@dosfilos/application';

// El expediente de un alumno y su avance en cada credencial del seminario
// (`getCredentialProgress`, flag `graduation_audit`). Lo lee el personal
// académico del seminario, o el alumno el suyo.
export const credentialProgressApi = {
  get: async (input: { tenantId: string; personId: string }): Promise<CredentialProgress> => {
    const fn = callable<typeof input, CredentialProgress>('getCredentialProgress');
    return (await fn(input)).data;
  },
  /** El del alumno que llama (el portal): SIN `personId`. El servidor deduce la
   *  persona de la sesión; nunca acepta un `personId` de un alumno. */
  getOwn: async (input: { tenantId: string }): Promise<CredentialProgress> => {
    const fn = callable<typeof input, CredentialProgress>('getCredentialProgress');
    return (await fn(input)).data;
  },
};
